import { ReactNode } from 'react';

export const CarouselButton = ({
  children,
  textColor,
  onClick,
}: {
  children: ReactNode;
  textColor: string | undefined;
  onClick: () => void;
}) => {
  return (
    <button type="button" className="p-1 md:p-4 relative" onClick={onClick}>
      <span
        className="rounded-full border inline-flex p-1"
        style={{ color: textColor, borderColor: textColor }}
      >
        {children}
      </span>
    </button>
  );
};
